module.exports = __webpack_public_path__ + "static/media/afternoon-healthy-life-organic-svgrepo-com.d70f5ef2.svg";